import { render, staticRenderFns } from "./ConfigFilter.vue?vue&type=template&id=4c23ebf7"
import script from "./ConfigFilter.vue?vue&type=script&lang=js"
export * from "./ConfigFilter.vue?vue&type=script&lang=js"
import style0 from "./ConfigFilter.vue?vue&type=style&index=0&id=4c23ebf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports